import cn from 'classnames/bind'

import { Orgs } from 'app/dataTypes/reports/data/common/ordersByClasses'
import Sticky from 'app/common/templates-next/sticky'
import { useHoverByClass } from 'app/common/ui-components/table'

import HScrollbarsWShadow, {
  useSyncScrolls,
  HScrollContainer,
  HScrollableContent,
} from 'app/common/ui-components/h-scrollbars-w-shadow'

import LeftTable from './left-table'
import MainTable from './main-table'

import styles from './group-by-classes.scss'

export type Ref = HTMLInputElement
const cx = cn.bind(styles)
const sameRowClassBase = 'row_'

type Props = {
  data: Orgs
}

export const GroupByClasses = ({ data }: Props) => {
  const { items, total, ...others } = data

  const [
    topScrollerProps,
    middleScrollerProps,
    bottomScrollerProps,
    // updateBottomScroll
  ] = useSyncScrolls()

  const [handleMouseEnter, handleMouseLeave] = useHoverByClass(sameRowClassBase)

  return (
    <>
      <Sticky>
        {(ref, _, shadow) => (
          <HScrollContainer ref={ref} className={cx({ shadow }, styles.borderTop)}>
            <LeftTable className={cx(styles.columnFixed, styles.height)} />

            <HScrollableContent>
              <HScrollbarsWShadow
                hideVerticalScrollBar
                hideHorizontalScrollBar
                {...topScrollerProps}
              >
                <MainTable className={cx(styles.columnScrollable, styles.height)} {...others} />
              </HScrollbarsWShadow>
            </HScrollableContent>
          </HScrollContainer>
        )}
      </Sticky>

      <div>
        <HScrollContainer>
          <LeftTable
            className={styles.columnFixed}
            data={items}
            sameRowClassBase={sameRowClassBase}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />

          <HScrollableContent>
            <HScrollbarsWShadow
              className={styles.shadowContainer}
              hideVerticalScrollBar
              hideHorizontalScrollBar
              {...middleScrollerProps}
            >
              <MainTable
                className={styles.columnScrollable}
                data={items}
                sameRowClassBase={sameRowClassBase}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                {...others}
              />
            </HScrollbarsWShadow>
          </HScrollableContent>
        </HScrollContainer>

        <Sticky stickyBottom>
          {(ref, stuck, shadow) => (
            <HScrollContainer ref={ref} className={cx({ shadowTop: shadow, borderTop: !stuck })}>
              <LeftTable className={styles.columnFixed} total={total} />

              <HScrollableContent>
                <HScrollbarsWShadow hideVerticalScrollBar {...bottomScrollerProps}>
                  <MainTable className={styles.columnScrollable} total={total} {...others} />
                </HScrollbarsWShadow>
              </HScrollableContent>
            </HScrollContainer>
          )}
        </Sticky>
      </div>
    </>
  )
}
